import { Star } from "~/components/icons";

const SUPPORTER_LABEL = "Supporter";

export function SupporterPill({ className }: { className?: string }) {
  return (
    <span
      title="Soonlist supporter"
      className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-interactive-3 px-2 py-0.5 text-xs font-medium leading-none text-interactive-1${
        className ? ` ${className}` : ""
      }`}
    >
      <Star className="size-3" weight="fill" />
      {SUPPORTER_LABEL}
    </span>
  );
}

export function SupporterStar({ className }: { className?: string }) {
  return (
    <Star
      aria-label="Soonlist supporter"
      weight="fill"
      className={`inline-block size-3 shrink-0 text-interactive-1${
        className ? ` ${className}` : ""
      }`}
    />
  );
}
